import { render } from "./VolumeClaimTemplate.vue?vue&type=template&id=8b1a8fce&scoped=true"
import script from "./VolumeClaimTemplate.vue?vue&type=script&lang=js"
export * from "./VolumeClaimTemplate.vue?vue&type=script&lang=js"

import "./VolumeClaimTemplate.vue?vue&type=style&index=0&id=8b1a8fce&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b1a8fce"]])

export default __exports__